import { CONFIG_OPTIONS } from '../config/config-options';
declare const window: any;

/**
 * jsbridge api => app version
 */
const suportVersion = {
  IOS:{
    setSwid: '10.3.0' || null,
    accessibilityToggleStatus: '11.1.0' || null,
    saveUserInfo: '11.6.0' || null
  },
  ANDROID:{
    setSwid: 10300,
    accessibilityToggleStatus: 11100,
    saveUserInfo: 11600
  }
}

/**
 * Disney app IOS: DISNEY_MOBILE_IOS/9.1, language/zh, Mozilla/5.0 (iPhone; CPU iPhone OS 14_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148
 * Disney app Android: DISNEY_MOBILE_ANDROID/9100,language/zh,Mozilla/5.0 (Linux; Android 10; Redmi K20 Pro Premium Edition Build/QKQ1.190825.002; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/83.0.4103.101 Mobile Safari/537.36
 */

export const WECHAT = 'Wechat';
export const MINI_PROGRAM = 'Miniprogram';
export const DISNEY_IOS = 'DisneyIOS';
export const DISNEY_ANDROID = 'DisneyAndroid';
export const MOBILE = 'Mobile';
export const BROWSER = 'Browser';

export class PlatformDetect {
  public userAgent;

  constructor() {
    this.userAgent = navigator.userAgent;
  }

  isWx() {
    const pattern = /MicroMessenger/;
    return pattern.test(this.userAgent);
  }

  isMiniP() {
    const pattern = /[m|M]ini[p|P]rogram/;
    return pattern.test(this.userAgent);
  }

  isDisneyIOS() {
    const pattern = /DISNEY_MOBILE_IOS/;
    return pattern.test(this.userAgent);
  }

  isDisneyAndroid() {
    const pattern = /DISNEY_MOBILE_ANDROID/;
    return pattern.test(this.userAgent);
  }

  isAndroid() { 
    const pattern = /android/;
    return pattern.test(this.userAgent.toLocaleLowerCase());
  }

  isApp() {
    return this.isDisneyAndroid() || this.isDisneyIOS();
  }

  isIPad() {
    const pattern = /(iPad|PlayBook)/;
    return pattern.test(this.userAgent.toLocaleLowerCase());
  }

  isMobile() {
    const pattern = /Mobile/;
    return pattern.test(this.userAgent);
  }

  isMobl() {
    return /(phone|pad|pod|iPhone|iPod|ios|webOS|iPad|Android|Mobile|Opera Mini|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent);
  }

  isWeb = ()=> {
    return this.isPcWeb() || this.isMobileWeb();
  }

  isPcWeb = () => { 
    return !this.isMobl() && !this.isWx() && !this.isApp();
  }

  isMobileWeb = () => { 
    const isMobl = this.isMobl();
    const isWeb = !this.isWx() && !this.isApp();
    const userAg = window.navigator?.userAgentData;
    let isMobile = false;
    if (userAg) {
      userAg.getHighEntropyValues(['platform', 'mobile']).then(ua => {
        if (ua.mobile) {
          isMobile = true;
        }
      });
      return (isMobl || isMobile) && isWeb;
    } else { 
      return isMobl && isWeb;
    }
  }

  detect() {
    return this.isWx() ? (this.isMiniP() ? MINI_PROGRAM : WECHAT) :
      (this.isDisneyIOS() ? DISNEY_IOS :
        ( this.isDisneyAndroid() ? DISNEY_ANDROID :
          ( this.isPcWeb() ? BROWSER : MOBILE)));
  }

  getPlatform() {
    return this.isWx() ? 'wechat' : (this.isApp() ? 'app' : 'browser');
  };

  getAndroidAppVersion(f: string){
    return suportVersion.ANDROID[f as keyof typeof suportVersion.ANDROID];
  }

  getIosAppVersion(f: string){
    return suportVersion.IOS[f as keyof typeof suportVersion.IOS]
  }

  versionStringCompare = (preVersion='', lastVersion='') => {
    var sources = preVersion.split('.');
    var dests = lastVersion.split('.');
    var maxL = Math.max(sources.length, dests.length);
    var result = 0;
    for (let i = 0; i < maxL; i++) {  
        let preValue = sources.length>i ? sources[i]:0;
        // @ts-ignore
        let preNum = isNaN(Number(preValue)) ? preValue.charCodeAt() : Number(preValue);
        let lastValue = dests.length>i ? dests[i]:0;
        // @ts-ignore
        let lastNum =  isNaN(Number(lastValue)) ? lastValue.charCodeAt() : Number(lastValue);
        if (preNum < lastNum) {
            result = -1;
            break;
        } else if (preNum > lastNum) { 
            result = 1;
            break;
        }
    }
    return result;
  }

}

export const platformDetectProvider = {
  provide: PlatformDetect,
  useClass: PlatformDetect,
  deps: [CONFIG_OPTIONS]
};